import React from 'react';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import "primeflex/primeflex.css";

export default function Dashboard() {
  const sections = [
    {
      icon: 'pi pi-flag',
      title: 'Objetivo de la polla',
      text: 'Cada jugador compite acumulando puntos por acertar marcadores de partidos y predicciones especiales del Mundial 2026. Si estan en celular, se desplazan por las apuestas haciendo scroll a la derecha.',
    },
    {
      icon: 'pi pi-calendar-plus',
      title: 'Apuestas de partidos',
      text: 'Debes apostar el marcador de todos los partidos disponibles. En playoffs la apuesta siempre corresponde al resultado de los 90 minutos reglamentarios; no cuentan alargue, tiempo extra ni penales.',
    },
    {
      icon: 'pi pi-pencil',
      title: 'Cambios de apuestas',
      text: 'Puedes crear o cambiar tus apuestas mientras sigan abiertas. Despues del cierre, el sistema bloquea cualquier modificacion.',
    },
    {
      icon: 'pi pi-lock',
      title: 'Cierre de apuestas',
      text: 'Fase de grupos y predicciones especiales cierran 24 horas antes del primer partido configurado por el admin. En playoffs, cada partido cierra individualmente 2 horas antes de jugarse.',
    },
    {
      icon: 'pi pi-clock',
      title: 'Apuesta automatica',
      text: 'Si no apuestas un partido antes del cierre, cuando el admin cargue el resultado el sistema registrara automaticamente una apuesta 2 - 2 para ti. Esa apuesta tambien puede sumar puntos si coincide con el resultado o con el empate.',
    },
    {
      icon: 'pi pi-star',
      title: 'Puntaje por partidos',
      text: 'Marcador exacto: 3 puntos. Ganador correcto o empate correcto sin marcador exacto: 1 punto. Resultado incorrecto: 0 puntos.',
    },
    {
      icon: 'pi pi-check-circle',
      title: 'Carga de resultados',
      text: 'Los puntos de cada partido se calculan cuando se carga el resultado oficial. Los resultados oficiales de partidos y especiales se basan en lo publicado por FIFA.com.',
    },
    {
      icon: 'pi pi-list',
      title: 'Predicciones especiales',
      text: 'Se eligen desde listas: 4 semifinalistas, campeon, maximo goleador, seleccion mas goleadora, guante de oro, mas asistidor y mejor jugador del mundial. Se pueden editar solo antes del cierre.',
    },
    {
      icon: 'pi pi-trophy',
      title: 'Puntos especiales',
      text: 'Cada semifinalista acertado vale 2 puntos, el campeon vale 3 puntos y cada categoria individual vale 2 puntos. Cuando el admin carga resultados oficiales, el sistema calcula automaticamente los puntos.',
    },
    {
      icon: 'pi pi-chart-bar',
      title: 'Ranking',
      text: 'El puntaje total es: puntaje inicial + puntos de partidos + puntos especiales. El ranking puede cambiar cada vez que se cargue un resultado o se asignen puntos especiales.',
    },
    {
      icon: 'pi pi-user-plus',
      title: 'Usuarios nuevos',
      text: 'El registro publico esta cerrado. Solo el admin crea usuarios y solo hasta finalizar la fase de grupos. Si alguien entra despues de resultados cargados, inicia con el puntaje total del ultimo jugador del ranking.',
    },
    {
      icon: 'pi pi-shield',
      title: 'Administrador y otros resultados',
      text: 'El administrador gestiona selecciones, partidos, resultados, usuarios, fechas y puntos especiales. No participa como jugador ni aparece en el ranking. En Otros resultados puedes revisar ranking y apuestas de los demas, sin modificarlas.',
    },
  ];

  return(
    <div className="surface-0 px-3 py-4 md:px-5 md:py-6 rules-page">
        <div className="text-center mb-4 md:mb-5 rules-hero">
            <div className="mb-2 md:mb-3 font-bold text-3xl md:text-5xl rules-title">
                <span className="text-900">Reglas </span>
                <span className="text-blue-600">Polla Gol 2026</span>
            </div>
            <div className="text-700 text-base md:text-lg line-height-3 mx-auto rules-intro" style={{ maxWidth: '760px' }}>
                Lee estas reglas antes de apostar. La idea es que todos sepamos exactamente como se cierran las apuestas, como se calculan los puntos y que pasa si alguien no apuesta.
            </div>
        </div>

        <div className="surface-100 border-round-xl p-3 md:p-4 mb-4 md:mb-5 rules-summary">
            <div className="grid text-left">
                <div className="col-12 md:col-4 mb-3 md:mb-0">
                    <div className="font-bold text-900 mb-1 md:mb-2 rules-summary-title">Partidos</div>
                    <div className="text-700 line-height-3 rules-summary-text">Exacto 3 pts, ganador/empate 1 pt, fallo 0 pts.</div>
                </div>
                <div className="col-12 md:col-4 mb-3 md:mb-0">
                    <div className="font-bold text-900 mb-1 md:mb-2 rules-summary-title">Especiales</div>
                    <div className="text-700 line-height-3 rules-summary-text">Semifinalistas, campeon y 5 categorias extra.</div>
                </div>
                <div className="col-12 md:col-4">
                    <div className="font-bold text-900 mb-1 md:mb-2 rules-summary-title">Premiacion</div>
                    <div className="text-700 line-height-3 rules-summary-text">El recaudo se reparte 70%, 20% y 10%.</div>
                </div>
            </div>
        </div>

        <div className="grid rules-grid">
            {sections.map((section) => (
                <div className="col-12 md:col-6 lg:col-4 mb-2 md:mb-3 rules-grid-col" key={section.title}>
                    <div className="h-full surface-card border-1 border-200 border-round-xl p-3 md:p-4 shadow-1 rules-card">
                        <div className="flex align-items-start gap-3">
                            <span className="flex align-items-center justify-content-center bg-blue-50 text-blue-600 flex-shrink-0 rules-icon" style={{ width: '44px', height: '44px', borderRadius: '12px' }}>
                                <i className={`${section.icon} text-2xl`}></i>
                            </span>
                            <div>
                                <div className="text-900 font-bold mb-1 md:mb-2 line-height-2 rules-card-title">{section.title}</div>
                                <div className="text-700 text-sm md:text-base line-height-3 rules-card-text">{section.text}</div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>

        <div className="surface-900 text-white border-round-xl p-3 md:p-4 mt-3 md:mt-4 rules-final">
            <div className="font-bold text-xl mb-2 md:mb-3">Resumen final</div>
            <div className="line-height-3 text-sm md:text-base">
                Todas las fechas se manejan con hora de Colombia/Bogota. Revisa tus apuestas antes de cada cierre y usa Otros resultados para seguir el ranking y comparar apuestas con los demas jugadores.
            </div>
        </div>
    </div>
    );
}
